import { isValid } from 'iban';
import * as Output from '../../Text';

export const iban = (v) => {
  if (!v) {
    return undefined;
  }

  if (!isValid(v)) {
    return Output.resolve('generic.errors.M007_ValidIBAN');
  }
  return undefined;
};
